import Vue from 'vue';
// import * as firebase from '@/plugins/firebase';
import { firebase } from 'mostra';

// const sleep = (msec: number) => new Promise((resolve) => {
//   setTimeout(() => resolve(), msec);
// });

class Store<S> {
  private instance: Vue

  // private vueInit: Function;

  constructor() {
    this.instance = new Vue({
      data: {
        cid: undefined,
        isBuyer: false,
        isExhibitor: false,
        uid: undefined,
        admin: false,
        init: false,
        email: undefined,
        emailVerified: false,
        isAnonymous: false,
      },
    });
    // this.vueInit = vueInit;
  }

  initial(vueInit: () => void): void {
    firebase.auth().onAuthStateChanged(async (auth) => {
      console.log('onAuthStateChanged callback');
      if (auth) {
        await auth.getIdTokenResult(true)
          .then((idToken) => {
            console.log(idToken.claims);
            this.admin = idToken.claims.admin;
          });
        this.uid = auth.uid;
        this.email = auth.email;
        if (auth.isAnonymous && auth.email) {
          console.log('onAuthStateChanged Auth as Anonymous and email');
          await firebase
            .auth()
            .signOut()
            .catch((error) => {
              console.error(error);
            });
        } else if (auth.isAnonymous) {
          console.log('onAuthStateChanged Auth as Anonymous');
          this.init = true;
          this.isAnonymous = true;
          this.isBuyer = false;
          this.isExhibitor = false;
        } else {
          console.log('onAuthStateChanged Auth as normal user', auth.uid);
          this.init = true;
          this.isAnonymous = false;
          const doc = await firebase
            .db()
            .collection('users_v1')
            .doc(auth.uid)
            .get();

          if (doc.exists) {
            console.log('doc exists');
            const data = doc.data();
            if (data) {
              this.cid = data.cid;
              this.isBuyer = data.buyer;
              this.isExhibitor = data.exhibitor;
            } else {
              this.cid = null;
              this.isBuyer = false;
              this.isExhibitor = false;
            }
          } else {
            // this.cid = null;
            // this.isBuyer = false;
            // this.isExhibitor = false;
            console.log('onAuthStateChanged Auth as normal user, but data is not exists');
            await firebase
              .auth()
              .signOut()
              .catch((error) => {
                console.error(error);
              });
          }
        }
        vueInit();
      } else {
        console.log('onAuthStateChanged no Auth and SignIn Anoymous');
        this.admin = false;
        this.isBuyer = false;
        this.isExhibitor = false;
        await firebase
          .auth()
          .signInAnonymously()
          .catch((error) => {
            console.error(error);
          });
      }
    });
  }

  get state(): S {
    return (this.instance.$data as any) as S;
  }

  set cid(cid: string | null) {
    this.instance.$data.cid = cid;
  }

  set uid(uid: string) {
    this.instance.$data.uid = uid;
  }

  set isBuyer(isBuyer: boolean) {
    this.instance.$data.isBuyer = isBuyer;
  }

  set isExhibitor(isExhibitor: boolean) {
    this.instance.$data.isExhibitor = isExhibitor;
  }

  set admin(admin: boolean) {
    this.instance.$data.admin = admin;
  }

  set email(email: string | null) {
    this.instance.$data.email = email;
  }

  set isAnonymous(flg: boolean) {
    this.instance.$data.isAnonymous = flg;
  }

  get init(): boolean {
    return this.instance.$data.init;
  }

  set init(flg: boolean) {
    this.instance.$data.init = flg;
  }
}

export interface State {
  cid: string | null;
  isBuyer: boolean;
  isExhibitor: boolean;
  uid: string;
  admin: boolean;
  init: boolean;
  isAnonymous: boolean;
  email: string | undefined;
  emailVerified: boolean;
}

class AuthStore extends Store<State> {}
export default AuthStore;
